/**
 * Hostname only (no protocol). Fallback when `NUXT_PUBLIC_GUMLET_HOST` is unset.
 * Used by `nuxt.config.ts` (Nuxt Image `baseURL` + `runtimeConfig.public.gumletHost`)
 * and `gumletUtils.ts` so defaults cannot drift.
 */
export const DEFAULT_GUMLET_PUBLIC_HOST = 'idtech.gumlet.io'
